import styled from 'styled-components/native';

import { horizontalScale } from '~/utils/layout';

export const Container = styled.View`
  width: ${horizontalScale(316)}px;
  background-color: ${({ theme }) => theme.colors.search.sidebarBackground};
`;
